export default "__VITE_ASSET__U0tmC_IT__"